export default __webpack_public_path__ + "static/media/breakfast-overlay@3x.faef8f96.png";